import { stringifyRichText } from '@nucleus/react-components';
import { SermonWeb } from '@nucleus/types/web/sermons/sermon';
import { JsonLd } from '@nucleus/web-theme-elements';
import React from 'react';
import { VideoObject } from 'schema-dts';
import { SermonEmbedVideoMediaItemWeb } from '../../../sermons/types/Sermon';

interface SermonStructuredDataProps {
  sermon?: SermonWeb;
}

export const SermonStructuredData = ({ sermon }: SermonStructuredDataProps): JSX.Element | null => {
  if (sermon === undefined) {
    return null;
  }

  const mediaItems = Object.values(sermon.mediaItems);

  const embedMedia = mediaItems.find((media): media is SermonEmbedVideoMediaItemWeb => media.type === 'embed/video');

  // For now, only support embedMedia. We don't have enough metadata to support livestream videos. Missing start and end datetime.
  if (embedMedia === undefined) {
    return null;
  }

  return (
    // https://developers.google.com/search/docs/appearance/structured-data/video
    <JsonLd<VideoObject>
      data={{
        '@context': 'https://schema.org',
        '@type': 'VideoObject',
        name: sermon.title,
        thumbnailUrl: sermon.mainImage?.image?.src,
        uploadDate: sermon.dateTimeIso,
        description: sermon.body !== undefined ? stringifyRichText(sermon.body) : undefined,
        embedUrl: embedMedia.href,
      }}
    />
  );
};
